module.exports = __webpack_public_path__ + "a6f59a272d27aa142d5175b978ea0ced.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/dracula-cape-s.png
// module id = 1263
// module chunks = 0